import React from 'react';

const NewsletterSubscribe: React.FC = () => (
  <div className="w-full flex flex-col items-center justify-center py-8">
    <h4 className="text-xl md:text-2xl font-bold mb-2 text-center bg-clip-text text-transparent bg-gradient-to-r from-white to-synorio-purple">
      Prijavite se za novosti, vodiče i AI savete
    </h4>
    <p className="text-gray-400 text-sm mb-6 text-center max-w-xl">
      Povremeno šaljemo korisne informacije iz sveta analitike, AI i automatizacije. Ne šaljemo spam. Možete se odjaviti u svakom trenutku.
    </p>
    <a
      href="https://synorio.us7.list-manage.com/subscribe?u=d91491f6b43b6abc9c569337d&id=8d3d16ee32"
      target="_blank"
      rel="noopener noreferrer"
      className="px-6 py-3 bg-synorio-purple text-white font-semibold rounded-xl hover:bg-synorio-purple/90 transition-colors text-base md:text-lg shadow-lg"
      style={{ minWidth: 160, textAlign: 'center', display: 'inline-block' }}
    >
      Prijavi se
    </a>
  </div>
);

export default NewsletterSubscribe; 